import {icon} from '#core/utils/style-utils.js';

import {registerTileSchema} from '#core/application/schema-registry.js';

import STREAMING_INDICATOR from './streaming-indicator.palette-schema.yaml';

registerTileSchema(STREAMING_INDICATOR);

export function generateStreamingIndicator(TILE) {
    return icon(TILE.INDICATOR_ICON_COLOR, TILE.INDICATOR_ICON_SRC);
}
